var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"icon-sort",attrs:{"color":"primary"}},[_vm._v(" "+_vm._s(_vm.sortIcon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }